<template>
	<div v-wechat-title="$route.meta.title[$store.state.CN_EN]">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "index",
		data() {
			return {}
		},
		components: {

		}
	}
</script>

<style scoped>

</style>
